// extracted by mini-css-extract-plugin
export default {"container":"yNLogcxHS1G6l1mipdk8","subcontainer":"ObFwmKbMcdusehOvqZh1","save":"bB2qyHfFH_Z8tuc3djlA","small":"Ki_gv5eRIWMF_4tdjRxm","large":"ireoBO1cO2EYxaUB82Lk"};